enum MenuItemIconAlignement {
  LEFT = 'icon-left',
  RIGHT = 'icon-right',
  LEFT_RIGHT = 'icon-left-right',
}
export { MenuItemIconAlignement };
